import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles,
  Paper,
  Button,
  Link,
} from "@material-ui/core";
import { apiEndpoints, apiGetRequest, apiPutRequest } from "src/utils/api/api";
import NavBarItem from "src/components/layout/NavBarItem";
import KmVersion from "src/components/layout/KmVersion";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import DescriptionIcon from "@material-ui/icons/Description";
import SettingsIcon from "@material-ui/icons/Settings";
import EventIcon from "@material-ui/icons/Event";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline"
import ListIcon from "@material-ui/icons/List";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import ListAltIcon from "@material-ui/icons/ListAlt";
import HowToVoteIcon from "@material-ui/icons/HowToVote";
import TodayIcon from "@material-ui/icons/Today";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Countdown, { zeroPad } from "react-countdown";
import Fab from "@material-ui/core/Fab";
import RefreshIcon from "@material-ui/icons/Refresh";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import HelpIcon from "@material-ui/icons/Help";
import InfoIcon from "@material-ui/icons/Info";
import EmailIcon from "@material-ui/icons/Email";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import InputIcon from "@material-ui/icons/Input";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import PolicyIcon from "@material-ui/icons/Policy";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import CloudDownloadOutlined from "@material-ui/icons/CloudDownloadOutlined";
import { getSystemLabel } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    "& > *": {
      margin: theme.spacing(2),
      width: theme.spacing(11),
      height: theme.spacing(11),
    },
  },
  mobileDrawer: {
    width: theme.dimensionscustom.menuWidth,
  },
  desktopDrawer: {
    width: theme.dimensionscustom.menuWidth,
    top: 64,
    height: "calc(100% - 64px)",
  },
  avatar: {
    cursor: "pointer",
    width: 42,
    height: 42,
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const renderer = ({ minutes, seconds, completed }) => {
  return (
    <Typography
      variant="h3"
      component="h2"
      align="center"
      color={minutes < 2 ? "error" : "primary"}
    >
      {zeroPad(minutes)}:{zeroPad(seconds)}
    </Typography>
  );
};

const NavBar = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  sessionTimeCounter,
  onMobileClose,
  openMobile,
  user,
  onSessionTimeFinished,
  onSessionTimeRefresh,
  isAuthorized,
  setLogoutUser,
  calendarEventsCount,
  incrementGlobalReloadCounter,
  votingsNoVoteCount,
  version,
  ...rest
}) => {
  const classes = useStyles();
  const location = useLocation();
  const [timeElapsed, setTimeElapsed] = useState(Date.now() + 150000);

  const items = [
    {
      href: "/aktualnosci",
      icon: AnnouncementIcon,
      title: "Aktualności",
      permissions: [],
    },
    {
      href: "/dokumenty",
      icon: DescriptionIcon,
      title: "Dokumenty",
      permissions: [],
    },
    {
      href: "/kalendarz",
      icon: TodayIcon,
      title: "Kalendarz",
      badge: calendarEventsCount,
      permissions: [],
      reloadPath: "kalendarz",
    },
    {
      href: "/glosowania",
      icon: HowToVoteIcon,
      title: "Głosowania",
      badge: votingsNoVoteCount,
      permissions: process.env.REACT_APP_PUBLIC_VOIDING === "true"
        ? []
        : ["read_access", "voting", "user_admin", "super_admin"],
    },
    {
      href: "/zarzadzanieglosowania",
      icon: ListAltIcon,
      title: "Zarządzanie głosowaniami",
      permissions: ["user_admin", "super_admin"],
    },
    {
      href: "/powiadomienia",
      icon: NotificationsIcon,
      title: "Powiadomienia",
      permissions: ["user_admin", "super_admin"],
    },
    {
      href: null,
      expandable: true,
      icon: PeopleAltIcon,
      title: "Użytkownicy",
      permissions: ["user_admin", "super_admin"],
      children: [
        {
          href: "/uzytkownicy",
          icon: PeopleAltIcon,
          title: "Uzytkownicy",
          permissions: ["user_admin", "super_admin"],
        },
        {
          href: "/profile",
          icon: AssignmentIndIcon,
          title: "Profile",
          permissions: ["user_admin", "super_admin"],
        },
      ],
    },
    {
      href: null,
      expandable: true,
      icon: SettingsIcon,
      title: "Administracja",
      permissions: ["user_admin", "super_admin"],
      children: [
        {
          href: "/administracja/zdarzenia",
          icon: EventIcon,
          title: "Monitorowanie zdarzeń",
          permissions: ["user_admin", "super_admin"],
        },
        {
          href: "/administracja/nieuprawnionydostep",
          icon: EventBusyIcon,
          title: "Nieuprawniony dostęp",
          permissions: ["user_admin", "super_admin"],
        },
        {
          href: "/administracja/slowniki",
          icon: ListIcon,
          title: "Słowniki",
          permissions: ["user_admin", "super_admin"],
        },
        {
          href: "/administracja/sekretariatkm",
          icon: AlternateEmailIcon,
          title: `Sekretariat KM ${getSystemLabel(
            "programShortcut",
            globalData.systemInfo
          )}`,
          permissions: ["user_admin", "super_admin"],
        },
        {
          href: "/administracja/zalogowaniuzytkownicy",
          icon: PeopleOutlineIcon,
          title: "Zalogowani użytkownicy",
          permissions: ["user_admin", "super_admin"],
        },
      ],
    },
    {
      href: null,
      expandable: true,
      icon: HelpIcon,
      title: "Pomoc",
      permissions: [],
      children: [
        {
          href: "/pomoc/pliki",
          icon: CloudDownloadOutlined,
          title: "Pliki do pobrania",
          permissions: [],
        },
        {
          href: "/pomoc/kontakt",
          icon: EmailIcon,
          title: "Kontakt",
          permissions: [],
        },
        {
          href: "/pomoc/deklaracjadostepnosc",
          icon: AccessibilityIcon,
          title: "Deklaracja dostępności",
          permissions: ["read_access", "voting", "user_admin", "super_admin"],
        },
        {
          href: "/pomoc/klauzulaobinf",
          icon: InfoIcon,
          title: "Klauzula obowiązku informacyjnego",
        },
        {
          href: "/pomoc/politykaprywatnosci",
          icon: PolicyIcon,
          title: "Polityka prywatności",
        },
        {
          href: "/pomoc/licencja",
          icon: PlaylistAddCheckIcon,
          title: "Licencja",
          permissions: ["read_access", "voting", "user_admin", "super_admin"],
        },
      ],
    },
  ];

  useEffect(() => {
    // console.log(isAuthorized);
    if (isAuthorized) {
      apiGetRequest(apiEndpoints.checkAuthorized.path, true)
        .then((data) => {})
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname, sessionTimeCounter]);
  
  useEffect(() => {
    // console.log(globalData);
    // console.log(globalData?.systemInfo?.sessionMaxTime);

    if (globalData?.systemInfo?.sessionMaxTime){
      setTimeElapsed(Date.now() + globalData.systemInfo.sessionMaxTime);
    }
  }, [globalData]);

  const refreshTimeElapsed = (event) => {
    event.preventDefault();
    onSessionTimeRefresh();
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileChange = (userProfile) => {
    enableGlobalLoader();

    apiPutRequest(
      apiEndpoints.setCurrentProfile.path,
      {
        id: userProfile.id,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        window.location.reload();
      })
      .catch((error) => {
        disableGlobalLoader();
        window.location.reload();
      });
    setAnchorEl(null);
  };

  const getCurrentUserProfileName = (user) => {
    let profile = user.userProfiles.filter((userProfile) => {
      return userProfile.id === user.profileId;
    });
    return profile?.length > 0 ? profile[0].name : "-";
  };

  const checkPermissionForMenu = (itemPermissions) => {
    if (user.userPermissionKeys) {
      if (itemPermissions.length === 0) {
        return true;
      } else {
        return itemPermissions.some(
          (r) => user.userPermissionKeys.indexOf(r) >= 0
        );
      }
    }
    return false;
  };

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      {user ? (
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          mt={2}
          mb={1}
        >
          {user.userProfiles?.length > 0 ? (
            <>
              <Button
                color="primary"
                variant="text"
                aria-controls="simple-menu"
                aria-label="Zmiana profilu"
                aria-haspopup="true"
                onClick={handleClick}
                size="small"
                startIcon={<AssignmentIndIcon>Zmień profil</AssignmentIndIcon>}
              >
                {getCurrentUserProfileName(user)}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {user.userProfiles.map((userProfile) => {
                  return (
                    <MenuItem
                      key={`profile${userProfile.id}`}
                      onClick={() => handleProfileChange(userProfile)}
                    >
                      {userProfile.name}
                    </MenuItem>
                  );
                })}
              </Menu>
            </>
          ) : (
            <></>
          )}

          <Link
            align="center"
            variant="h6"
            component={RouterLink}
            to="/mojekonto"
          >
            <Box display="flex" justifyContent="center">
              <Avatar className={classes.avatar}></Avatar>
            </Box>
            {user.username} ({user.firstName} {user.lastName})
          </Link>
          <Typography
            className={classes.name}
            color="initial"
            variant="body2"
          ></Typography>
          {isAuthorized ? (
            <Button
              color="secondary"
              variant="contained"
              size="small"
              onClick={setLogoutUser}
              className={classes.button}
              startIcon={<PowerSettingsNewIcon>wyloguj</PowerSettingsNewIcon>}
            >
              Wyloguj
            </Button>
          ) : (
            <Button
              color="primary"
              variant="contained"
              size="small"
              component={RouterLink}
              to={"/logowanie"}
              className={classes.button}
              startIcon={<InputIcon />}
            >
              Zaloguj
            </Button>
          )}
        </Box>
      ) : (
        <></>
      )}
      <Divider />
      <Box p={2}>
        <List>
          {items.map((item, index) =>
            checkPermissionForMenu(item.permissions) ? (
              <NavBarItem
                href={item.href}
                key={`${item.title}_${index}`}
                keyVal={`${item.title}_${index}`}
                title={item.title}
                icon={item.icon}
                expandable={item.expandable}
                badge={item.badge}
                children={item.children}
                reloadPath={item.reloadPath}
              />
            ) : (
              <></>
            )
          )}
        </List>
      </Box>
      <Box className={classes.root}>
        <Paper elevation={4}>
          <Box paddingTop={1}>
            <Countdown
              date={timeElapsed}
              renderer={renderer}
              onComplete={onSessionTimeFinished}
            />
            <Box display="flex" width="100%" justifyContent="center">
              <Fab
                size="small"
                color="primary"
                aria-label="odśwież"
                title="Odśwież"
                onClick={refreshTimeElapsed}
              >
                <RefreshIcon />
              </Fab>
            </Box>
          </Box>
        </Paper>
      </Box>
      <Box flexGrow={1}></Box>
      <Box p={2} m={2}>
        <KmVersion version={version} />
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

const mapStateToProps = (state) => ({
  sessionTimeCounter: state.globalData.sessionTimeCounter,
  globalData: state.globalData,
});

export default connect(mapStateToProps, null)(NavBar);
